// Copyright (c) Docugami, Inc. All rights reserved.

import { useMemo } from "react";
import { OperationMetadata, selectAllReportRemoteOperations } from "store/reports/reportsSlice";
import { createSelectReportOperationByMetadataPredicate } from "store/reports/selectors";
import { useAppSelector } from "./redux"

export const useReportOperationStatus = (operationId?: string): boolean => {
    return useAppSelector(state => !!operationId && !!selectAllReportRemoteOperations(state.reportOperations.remoteOps).find(x => x.operationId === operationId));
}

export const useReportOperationByMetadataStatus = (predicate: (operationMetadata: OperationMetadata) => boolean): boolean => {
    const selectReportOperationByMetadataStatus = useMemo(createSelectReportOperationByMetadataPredicate, [predicate])

    return useAppSelector(state => {
        return !!selectReportOperationByMetadataStatus(state, predicate).length
    });
}
